export default "__VITE_ASSET__BRgFeYK8__"